import { Component, Input, OnInit } from '@angular/core';
import { DarkModeService } from '../../services/darkmode.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ayr-in-my',
  imports: [TranslateModule],
  templateUrl: './ayr-in-my.component.html',
  styleUrl: './ayr-in-my.component.scss',
})
export class AyrInMyComponent implements OnInit {
  @Input() isCompany = false;
  isDarkMode!: boolean;
  constructor(private darkModeService: DarkModeService) {}
  ngOnInit(): void {
    this.darkModeService.isDarkMode.subscribe((enabled) => {
      this.isDarkMode = enabled;
    });
  }
}
